// Runtime config module that works in dev and in Docker/NGINX
// Prefers window._env_ injected at runtime, falls back to build-time env

const raw =
  (typeof window !== "undefined" && window._env_ && window._env_.REACT_APP_BACKEND_URL) ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

const reportRaw =
  (typeof window !== "undefined" && window._env_ && (window._env_.REPORT_URL_BASE || window._env_.REACT_APP_REPORT_URL_BASE)) ||
  process.env.REACT_APP_REPORT_URL_BASE ||
  "";

const ensureProtocol = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const protocol = typeof window !== "undefined" ? window.location.protocol : "http:";
  return `${protocol}//${url}`;
};

const config = { backendUrl: ensureProtocol(raw), reportUrlBase: ensureProtocol(reportRaw) };

export default config;
